var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("vuex-currency-input", {
    attrs: {
      getter: () => _vm.params.value,
      setter: (value) => _vm.setValue(value),
      filled: "",
      disabled: _vm.isDisabled,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }